<ng-container *ngIf="messageImageURL$ | async as messageImageURL">
  <img src="{{ messageImageURL }}" class="message-image" />
</ng-container>
<glxy-chat-message [isTyping]="loading">
  <div [innerHTML]="((businessName$ | async) || '') + (rendered$ | async) + ((smsLink$ | async) || '')"></div
></glxy-chat-message>
